import React from 'react';
import { FluidObject } from 'gatsby-image';
import PressSection from '../../../components/Homepage/PressSection';

type ImageType = {
  fluid: FluidObject;
  description: string;
};

export interface PressContainerProps {
  content: {
    title: string;
    desktopImages: ImageType[];
  };
}

export const PressContainer: React.FC<PressContainerProps> = ({ content }) => {
  if (!content) {
    return null;
  }
  const { title, desktopImages: rawDesktopImages } = content;

  return (
    <PressSection
      title={title}
      desktopImages={rawDesktopImages.map(img => ({
        fluid: img.fluid,
        altText: img.description,
      }))}
    />
  );
};

export default PressContainer;
